import * as React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { brandColors } from 'brandColors';
import { Message } from './Message';

interface Props {
  fileName: string;
}

export const Success: React.FC<Props> = (props) => {
  const { fileName } = props;
  return (
    <Message>
      <CheckIcon style={{ fontSize: '16px', fill: brandColors.colors.green.DEFAULT }} />
      <h4>
        Your file <span className="font-bold">{fileName}</span> has been successfully uploaded.
      </h4>
    </Message>
  );
};
Success.displayName = 'CustomerAssignment.Message.Success';
